import React, {
    useState,
    useEffect,

} from "react"
import {Typography } from './ot'

const BaseCardView1_4 = ({
    value = "元件項目：標題、主文內容、圖片、按鈕、Hashtag",
    className = "text-gray-600 mt-1 text-sm",
    style = {},
}, ref) => {


    return (
        <Typography.P className={className} style={style}>{value}</Typography.P>

    )
}

export default BaseCardView1_4
